import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';



const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class ScheduleList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            schedules: [],
            filter: {},
            dataSetPrimaryKey: "schedule_id",
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
    }
    

    async componentDidMount() {
        console.log("In ScheduleList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const schedules = await this.getSchedules({cityscope: this.props.match.params.cityscope});
            this.setState({ schedules });
        } catch (e) {
            alert(e);
        }
        document.title = "Schedule lookup";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ schedules: [] });        
    }


    
    async getSchedules(filter) {
        console.log("Inside getSchedules() ");
        
        return API.get("colin", "/schedules", { 'queryStringParameters': filter});
      
    }

    

    addRecord = async event => {
        let schedules = [...this.state.schedules];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        schedules.unshift({
            appendix:(this.state.schedules[0].appendix||0)+1,
            issue_date: null,
            cityscope: this.props.match.params.cityscope,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({schedules});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/schedules/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/schedules/${record["schedule_id"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

       
        //Check street name not blank
        if (record.cityscope === "") {
            return [false,"Cityscope cannot be blank. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let schedules = [...this.state.schedules];
   
        schedules[cellInfo.index][cellInfo.column.id] = event.target.value;
        schedules[cellInfo.index].modified = true;
        this.setState({schedules});
    };
    handleNumberChange = (cellInfo, event) => {
        let schedules = [...this.state.schedules];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        schedules[cellInfo.index][cellInfo.column.id] = Number(val);
        schedules[cellInfo.index].modified = true;
        this.setState({schedules});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let schedules = [...this.state.schedules];
        schedules[cellInfo.index][cellInfo.column.id] = event.target.checked;
        schedules[cellInfo.index].modified = true;
        this.setState({schedules});
    };

    handleDateChange = (cellInfo, event) => {
        let schedules = [...this.state.schedules];
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(event);

        schedules[cellInfo.index][cellInfo.column.id] = dt.toLocaleDateString('en-AU',options);
        schedules[cellInfo.index].modified = true;
        this.setState({schedules});

    }
    

    handleSave = async (cellInfo, event) => {
        console.log("In handleblur");
        this.setState({ showAlert: false, showWarning: false });
        let schedules = [...this.state.schedules];
        for (var i=0; i<schedules.length; i++){
            const validation = this.validateRecord(schedules[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (schedules[i].hasOwnProperty("modified")) {
                    if (schedules[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (schedules[i].hasOwnProperty("new_record")) {
                                if (schedules[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(schedules[i]);
                            if (result.result) {
                                schedules[i].modified = false;
                                if (schedules[i].hasOwnProperty("new_record")) {
                                    if (schedules[i].new_record === true) {

                                        schedules[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    schedules[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true, savingNewRecord: false });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if (schedules[i].new_record === true) {
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
                
                return;
            }
        }   
        if (schedules[0].hasOwnProperty("sort_order")) {
            schedules.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({schedules});

    }


    renderEditable = cellInfo => {
        const cellValue = this.state.schedules[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'schedule_id',
                Header: 'ID',
                maxWidth: 80,
                accessor: 'schedule_id' 
                

        }
        , 
            {
                id: 'cityscope',
                Header: 'Cityscope',
                maxWidth: 150,
                accessor: 'cityscope' 
                
                

        }
        , {
                id: 'issue_date',
                Header: 'Issue Date',            
                accessor: 'issue_date',
                maxWidth: 150,
                Cell: this.renderEditable
                

            }, {
                id: 'appendix',
                Header: 'Appendix',            
                accessor: 'appendix',
                maxWidth: 150,
                Cell: this.renderEditable

            }
            // , {
            //     id: 'next_issue_date',
            //     Header: 'Next Issue Date',
            //     maxWidth: 200,
            //     accessor: d => {
            //         if (d.next_issue_date) {
            //             return Moment(d.next_issue_date)
            //                 .local()
            //                 .format("DD-MM-YYYY")
            //         }
            //         else { return null }
            //     },
            //     Cell: this.renderEditable

            // },
            // {
            //     id: 'previous_issue_date',
            //     Header: 'Previous Issue Date',
            //     maxWidth: 200,
            //     accessor: d => {
            //         if (d.previous_issue_date) {
            //             return Moment(d.previous_issue_date)
            //                 .local()
            //                 .format("DD-MM-YYYY")
            //         }
            //         else { return null }
            //     },
            //     Cell: this.renderEditable

            // }
           ,
            {
                id: 'created_by',
                Header: 'Created By',
                maxWidth: 150,
                accessor: 'created_by'
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={false}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="schedules">
               <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                <Row >
                    <Col className="text-right" >           
                    <LinkContainer to={{pathname:`/cityscopes`}} >
                                            <Button type="button" variant="info"  size="sm">Back to Cityscopes</Button></LinkContainer>{" "}                 
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.schedules) : this.renderTable(this.state.schedules)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="ScheduleList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
